<!-- 会员概况 -->
<template>
  <div>
    <div class="tableTitle">
      <span class="title-color-box"></span>
      <span class="tips">会员概览</span>
    </div>
    <el-table
      :data="countTable"
      border
      style="width: 100%"
      :maxHeight="maxHeight"
    >
      <template slot="empty">
        <empty />
      </template>
      <el-table-column
        prop="memberCount"
        label="会员数"
        width="220"
        align="right"
      />
      <el-table-column
        prop="newMemberCount"
        label="新增会员数"
        width="220"
        align="right"
      />
      <el-table-column
        prop="upgradeCount"
        label="升级会员数"
        width="220"
        align="right"
      />
      <el-table-column
        prop="downgradeCount"
        label="降级会员数"
        width="220"
        align="right"
      />
      <el-table-column
        prop="unbindCount"
        label="解绑会员数"
        min-width="220"
        align="right"
      />
    </el-table>
    <div class="tableTitle">
      <span class="title-color-box"></span>
      <span class="tips">积分概览</span>
    </div>
    <el-table
      :data="countTable"
      border
      style="width: 100%"
      :maxHeight="maxHeight"
    >
      <template slot="empty">
        <empty />
      </template>
      <el-table-column
        prop="totalScore"
        label="总积分"
        width="220"
        align="right"
      />
      <el-table-column
        prop="occurScore"
        label="发放积分"
        width="220"
        align="right"
      />
      <el-table-column
        prop="consumedScore"
        label="消耗积分"
        width="220"
        align="right"
      />
      <el-table-column
        prop="tradeScore"
        label="交易积分"
        width="220"
        align="right"
      />
      <el-table-column
        prop="expiredScore"
        label="过期积分"
        min-width="220"
        align="right"
      />
      <el-table-column
        prop="usageRateStr"
        label="积分核销率"
        min-width="220"
        align="right"
      />
    </el-table>
    <div class="tableTitle">
      <span class="title-color-box"></span>
      <span class="tips">积分互动</span>
    </div>
    <el-table
      :data="countTable"
      border
      style="width: 100%"
      :maxHeight="maxHeight"
    >
      <template slot="empty">
        <empty />
      </template>
      <el-table-column
        prop="changedMemberCount"
        label="积分变更会员数"
        width="220"
        align="right"
      />
      <el-table-column
        prop="issuedMemberCount"
        label="积分发放会员数"
        width="220"
        align="right"
      />
      <el-table-column
        prop="consumedMemberCount"
        label="积分消耗会员数"
        width="220"
        align="right"
      />
      <el-table-column
        prop="tradeIssuedMemberCount"
        label="交易发放会员数"
        width="220"
        align="right"
      />
      <el-table-column
        prop="expiredMemberCount"
        label="积分过期会员数"
        min-width="220"
        align="right"
      />
    </el-table>
    <div class="tableTitle">
      <span class="title-color-box"></span>
      <span class="tips">会员成交</span>
    </div>
    <el-table
      :data="countTable"
      border
      style="width: 100%"
      :maxHeight="maxHeight"
    >
      <template slot="empty">
        <empty />
      </template>
      <el-table-column
        prop="memberTotalCountTrade"
        label="会员成交人数"
        width="220"
        align="center"
      />
      <el-table-column
        prop="saleTotalAmountTrade"
        label="会员成交金额"
        width="220"
        align="center"
      />
      <el-table-column
        prop="memberCountTrade"
        label="新会员成交人数"
        width="220"
        align="right"
      />
      <el-table-column
        prop="saleAmountTrade"
        label="新会员成交金额"
        width="220"
        align="right"
      />
      <el-table-column
        prop="amountRatioStrTrade"
        label="新会员成交率"
        width="220"
        align="right"
      />
      <el-table-column
        prop="customerUnitPriceTrade"
        label="新会员客单价"
        width="220"
        align="right"
      />
      <el-table-column
        prop="firstTradeMemberCountTrade"
        label="会员首购人数"
        min-width="220"
        align="right"
      />
      <el-table-column
        prop="repurchaseTradeMemberCountTrade"
        label="会员复购人数（近365天）"
        min-width="220"
        align="right"
      />
    </el-table>
  </div>
</template>

<script>
import Empty from "../../components/empty.vue";
export default {
  name: "memberOverviewAnalysis",
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Object,
      default: () => {},
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
  },
  computed: {
    countTable() {
      if (this.tableData) {
        let tradeObj = this.tableData.trade || {};
        let trade = {};
        for (let key in tradeObj) {
          trade[`${key}Trade`] = tradeObj[key] || 0;
        }
        const combinedData = {
          ...(this.tableData.interaction || {}),
          ...(this.tableData.member || {}),
          ...(this.tableData.score || {}),
          ...(trade || {}),
        };
        return [combinedData];
      } else {
        return [];
      }
    },
  },
};
</script>
<style scoped lang="scss">
.tableTitle {
  margin-bottom: 8px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  .title-color-box{
    display: inline-block;
    width: 2px;
    height: 14px;
    background-color: #3159ff;
    border-radius: 1px;
    margin-right: 8px;
    opacity: 1;
  }
  .tips{
    color: #333333;
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
  }
}
</style>
